import { ControlledCheckbox, ControlNumberField } from 'components/Form';
import type { BimContractOtherCostData } from 'gql/graphql';
import { validateLimitCost } from 'pages/Project/Common/hooks/prepareLimitsData';
import { cnMixSpace, GridItem } from 'uikit';

import cn from 'classnames';
import { isEmpty } from 'ramda';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useFieldArray } from 'react-hook-form';

import type { TEditOtherModalOtherLimitsProps } from '../../types';

import Styles from './BimEditOtherLimit.module.css';

export const BimEditOtherLimits = <T extends BimContractOtherCostData>(props: TEditOtherModalOtherLimitsProps<T>) => {
    const { control, constructionTypes, otherData, constructionTypeId, watch, areTooltipsHidden, orderBimRules } =
        props;

    const [disableFields, setDisableFields] = useState<Record<string, any>[]>([]);
    const otherCostLimits = otherData?.otherCostLimits;

    const limitsFields = watch('otherCostLimits');

    const { fields, append } = useFieldArray({
        control,
        name: 'otherCostLimits',
    });

    useEffect(() => {
        if (constructionTypes && isEmpty(fields)) {
            constructionTypes.forEach((type) => {
                const currentWorkOrderCostLimit = otherCostLimits?.find(
                    (limit) => limit.constructionType.id === type?.id,
                );

                const isChecked = otherCostLimits?.some((limit) => limit.constructionType.id === type?.id);

                append({
                    [`checkbox_${type?.id}`]: isChecked,
                    [`cost_${type?.id}`]: currentWorkOrderCostLimit?.cost || '',
                });
            });
        }
    }, [append, constructionTypes, otherCostLimits, fields]);

    useEffect(() => {
        if (limitsFields) {
            setDisableFields(limitsFields);
        }
    }, [limitsFields]);

    return (
        <>
            <div className={Styles.wrapperFields}>
                <span style={{ width: '226px' }} className={cn(cnMixSpace({ mR: 's', mB: 'm' }), Styles.labelBlock)}>
                    Вид строительства
                </span>
                <span className={Styles.labelBlock}>Сумма, руб. без НДС</span>
            </div>
            {fields.map((item, index) => {
                const constructionTypeIdLimit = constructionTypes?.[index]?.id;
                const checkboxLabel = constructionTypes?.find((type) => type?.id === constructionTypeIdLimit)?.name;

                return (
                    <div className={Styles.wrapperFields} key={item.id}>
                        <GridItem className={cn(cnMixSpace({ mR: 's' }), Styles.leftBlock)}>
                            <GridItem>
                                <ControlledCheckbox
                                    key={`${item.id}`}
                                    name={`otherCostLimits.${index}.checkbox_${constructionTypeIdLimit}`}
                                    label={checkboxLabel || ''}
                                    size="m"
                                    control={control}
                                    disabled={constructionTypeIdLimit === constructionTypeId || !orderBimRules?.canEdit}
                                />
                            </GridItem>
                        </GridItem>
                        <GridItem style={{ width: '100%' }}>
                            <ControlNumberField
                                name={`otherCostLimits.${index}.cost_${constructionTypeIdLimit}`}
                                labelPosition="left"
                                control={control}
                                size="s"
                                disabled={
                                    !disableFields?.[index]?.[`checkbox_${constructionTypeIdLimit}`] ||
                                    !orderBimRules?.canEdit
                                }
                                decimalScale={0}
                                style={{ width: '100%' }}
                                required
                                rules={{
                                    validate: validateLimitCost({
                                        isSelected: disableFields?.[index]?.[`checkbox_${constructionTypeIdLimit}`],
                                    }),
                                }}
                                hideOnDisabled
                                isTooltipHidden={areTooltipsHidden}
                            />
                        </GridItem>
                    </div>
                );
            })}
        </>
    );
};

BimEditOtherLimits.displayName = 'BimEditOtherLimits';
